<app-dashboard
  style="position: absolute; width: 100%; z-index: 2000; top: 0"
  *ngIf="isTemplateVisible"
></app-dashboard>
<router-outlet> </router-outlet>

<app-popup-exclusive-deals [isVisible]="true"></app-popup-exclusive-deals>
<app-enddetails
  *ngIf="isTemplateVisible && !isAdmin && !isPageSale"
></app-enddetails>
<app-widget-container></app-widget-container>
<app-floating-account *ngIf="isShowed"></app-floating-account>
